import React from 'react';
import { useNavigate } from 'react-router-dom';
// Abas no padrão do sistema (`recepcao-tabs`), as mesmas da lista e da Recepção.
import '../../recepcao/pages/Recepcao.css';
import AvisoDeDivergencia from './AvisoDeDivergencia';

export type AbaDoQualificado = 'regras' | 'contratos' | 'pagamentos';

interface AbasDoQualificadoProps {
  ativa: AbaDoQualificado;
  /** O mesmo `state` que as três telas já trocam entre si na navegação. */
  estado: {
    item: unknown;
    origem: unknown;
    qualificado_tipo: string;
    qualificado_uuid?: string;
  };
  /**
   * Abre o detalhe de uma competência divergente (at-04). Só a aba Regras sabe fazer isso
   * (é lá que o modal da fotografia vive), então nas outras duas o aviso apenas informa —
   * em vez de oferecer um botão que não leva a lugar nenhum.
   */
  onAbrirCompetencia?: (periodo: string) => void;
}

const ABAS: { chave: AbaDoQualificado; rotulo: string; rota: string }[] = [
  { chave: 'regras', rotulo: 'Regras', rota: '/comissionamentos/regras' },
  { chave: 'contratos', rotulo: 'Contratos', rota: '/comissionamentos/contratos' },
  { chave: 'pagamentos', rotulo: 'Pagamentos', rota: '/comissionamentos/pagamentos' },
];

/**
 * Abas Regras / Contratos / Pagamentos do detalhe de uma cooperativa ou voluntário
 * (16/09/2026, a pedido do Victor — a coluna "Ações" da lista deixou de existir e o caminho
 * para as três passou a ser o nome do qualificado, que abre em Regras).
 *
 * ⚠️ **As três URLs continuam existindo** (decisão do Victor): a aba é a própria rota, não um
 * estado de tela. É o que mantém F5, "voltar" do navegador e link antigo funcionando — as
 * três telas eram rotas desde sempre e há links guardados por aí.
 *
 * O bloco que isto substitui (`page-nav` com três `nav-btn`) estava **copiado nas três
 * telas**, com a ativa marcada à mão em cada uma — segunda cópia já é sinal de extrair.
 */
const AbasDoQualificado: React.FC<AbasDoQualificadoProps> = ({
  ativa,
  estado,
  onAbrirCompetencia,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="recepcao-tabs">
        {ABAS.map(({ chave, rotulo, rota }) => (
          <button
            key={chave}
            type="button"
            className={`recepcao-tab ${ativa === chave ? 'active' : ''}`}
            // A aba ativa não navega: recarregaria a própria tela e perderia a posição.
            onClick={() => ativa !== chave && navigate(rota, { state: estado })}
            aria-current={ativa === chave ? 'page' : undefined}
          >
            {rotulo}
          </button>
        ))}
      </div>
      {/*
        O aviso de divergência (at-04) mora AQUI, e não em cada tela, pela mesma razão que as
        abas moram: ele vale para o qualificado, não para a aba — e repeti-lo nas três telas
        seria a terceira cópia do mesmo bloco. Decisão do Victor (18/09/2026): por ora o aviso
        aparece só nas abas do qualificado, não na lista nem na Home.
      */}
      <AvisoDeDivergencia
        qualificadoTipo={estado.qualificado_tipo}
        qualificadoUuid={estado.qualificado_uuid}
        onAbrirCompetencia={onAbrirCompetencia}
      />
    </>
  );
};

export default AbasDoQualificado;
